import { render, staticRenderFns } from "./AuthSignupDemoForm.vue?vue&type=template&id=2ee4a0a1"
import script from "./AuthSignupDemoForm.vue?vue&type=script&lang=js"
export * from "./AuthSignupDemoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports